<template>
    <div class="form__journey-time d-flex justify-content-between">
      <div class="font-big font-weight-400 font-style-form-items">
        {{ $t('duration') }}
      </div>
      <div class="font-big font-weight-400 font-style-form-items">
        {{ data.duration.hours }} {{ $t('shortened_hours') }} {{ data.duration.minutes }} {{ $t('shortened_minutes') }}
      </div>
    </div>

    <div class="form__journey-distance d-flex justify-content-between" v-if="data.distance">
      <div class="font-big font-weight-400 font-style-form-items">
        {{ $t('distance') }}
      </div>
      <div class="font-big font-weight-40 font-style-form-items">
        {{ data.distance }} km.
      </div>
    </div>

    <div class="hr-line m-2 mb-3"></div>

  <div class="form__journey-price d-flex justify-content-between align-items-baseline">
    <div class="font-big font-weight-400 font-style-form-items">
     {{ $t('price') }}
    </div>
    <h4>
      {{ data.price }} &euro;
    </h4>
  </div>
</template>

<script lang="ts">
import './orderPaymentDataWrapper.scss';
import {defineComponent} from "vue";
import type {PropType} from "vue";

export default defineComponent({
  name: 'OrderPaymentDataWrapperComponent',
  props: {
    data: {
      type: <PropType<{
        duration: {
          hours: number,
          minutes: number
        },
        distance: number|null,
        price: number,
      }>>Object,
    }
  }

})
</script>